import NETWORKS from "./networks.json";
import { sepolia, mumbai, polygon } from "thirdweb/chains";

for (const chainId in NETWORKS) {
    let data;
    switch (chainId) {
        case "11155111":
            data = sepolia;
            break;
        case "80001":
            data = mumbai;
            break;
        case "137":
            data = polygon;
            break;
        default:
            data = undefined;
            break;
    }
    NETWORKS[chainId].thirdWebData = data;
}

export { NETWORKS };
